import React from 'react';
import { Typography, Empty } from 'antd';
import { ProjectOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const ProjectPage = () => {
return (
    <div>
    <Title level={2}><ProjectOutlined style={{ marginRight: 8 }} /> Projects</Title>
    <Paragraph>
        Manage ongoing and completed projects linked to confirmed quotes.
        Track progress, assign managers, and view project details.
    </Paragraph>
    {/* Placeholder */}
    <Empty description="Project management functionality coming soon." />
    </div>
);
};

export default ProjectPage;